<script setup>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import CreateButton from '@/components/CreateButton.vue';
import EditUser from '@/components/EditUser.vue';
defineOptions({
  name: 'UserView',
});

let users = ref([]);
const store = useStore();
const router = useRouter();
const create = ref(false);
const toggleCreate = () => {
  create.value = !create.value;
};

const getUsers = async () => {
  users.value = await store.dispatch('get', {
    end_point: 'users',
  });
};

onMounted(async () => {
  await getUsers();
});

const changeUser = async ({ user_name, user_id, password, is_admin }) => {
  await store.dispatch('put', {
    end_point: 'user',
    body_vars: { user_name, user_id, password, is_admin },
  });

  await getUsers();
};

const createUser = async ({ user_name, password, is_admin }) => {
  await store.dispatch('post', {
    end_point: 'user',
    body_vars: {
      user_name,
      password,
      is_admin,
    },
  });
  router.go();
};

const remove = async (user_id) => {
  await store.dispatch('delete', {
    end_point: 'user',
    path_vars: { user_id },
  });

  await getUsers();
};
</script>
<template>
  <div class="container is-fluid">
    <div class="content">
      <p class="title is-3">Gebruikers</p>
      <table class="table">
        <thead>
          <tr>
            <td>id</td>
            <td>naam</td>
            <td>is_admin</td>
            <td>wachtwoord</td>
            <td>last_login</td>
            <td></td>
          </tr>
        </thead>
        <tr v-if="create" @cancel="toggleCreate">
          <EditUser
            :user-name="''"
            :user-id="''"
            :new-user="true"
            :last-login-attempt="''"
            :is-admin="'N'"
            @createuser="createUser"
            @cancel="toggleCreate"
          ></EditUser>
        </tr>
        <tr v-for="(user, index) in users" :key="index">
          <EditUser
            :user-name="user.user_name"
            :user-id="user.user_id"
            :new-user="false"
            :is-admin="user.is_admin"
            :last-login-attempt="user.last_login_attempt"
            @remove="remove"
            @changeuser="changeUser"
          ></EditUser>
        </tr>
      </table>
      <CreateButton
        :button-text="'new user'"
        :button-class="'is-link'"
        :emit-message="'toggleCreate'"
        @toggleCreate="toggleCreate"
      ></CreateButton>
    </div>
  </div>
</template>
<style lang="scss">
td {
  border: 1px solid gray;
}
</style>
